// src/pages/DatenschutzPage.js
import React from "react";
import "./DatenschutzPage.css";
import { Link } from "react-router-dom";


function DatenschutzPage() {
  return (
    <div className="datenschutz-page">
      <div className="legal-container">
        <h1>Datenschutzerklärung</h1>

        <p>
          Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen.
          Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der
          geltenden Datenschutzgesetze, insbesondere der Datenschutz-Grundverordnung (DSGVO).
        </p>

        <h2>1. Verantwortlicher</h2>
        <p>
          Edens Ernte<br />
          Julia Becker<br />
          Schmiedgasse 16<br />
          86943 Thaining<br />
          Deutschland<br />
          E-Mail: info@edens-ernte.app
        </p>

        <h2>2. Welche Daten verarbeitet werden</h2>
        <p>
          Bei der Nutzung der Plattform können insbesondere folgende Daten verarbeitet werden:
        </p>
        <ul>
          <li>E-Mail-Adresse und Benutzername bei Registrierung und Login</li>
          <li>freiwillige Profilangaben wie Name, Adresse, Postleitzahl oder Telefonnummer</li>
          <li>Inhalte, die Nutzer selbst einstellen, z. B. Angebote, Beiträge, Bilder und Kommentare</li>
          <li>Nachrichten, die zwischen Nutzern innerhalb der Plattform ausgetauscht werden</li>
          <li>technische Daten, die zur Bereitstellung, Sicherheit und Stabilität der App erforderlich sind</li>
          <li>Standortbezogene Daten in Form von Adress- oder Postleitzahlangaben zur Darstellung von Angeboten auf der Karte</li>
        </ul>

        <h2>3. Zweck der Verarbeitung</h2>
        <p>
          Die Verarbeitung erfolgt ausschließlich zur Bereitstellung und Verbesserung der Plattform,
          zur Anzeige und Verwaltung von Angeboten, zur Kommunikation zwischen Nutzern,
          zur Nutzung des Forums, zur Speicherung hochgeladener Inhalte sowie zur
          Gewährleistung eines sicheren und stabilen Betriebs der App.
        </p>

        <h2>4. Technische Dienstleister / Firebase</h2>
        <p>
          Zur technischen Bereitstellung der Plattform verwenden wir Dienste von Google Firebase
          (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland).
          Dabei werden insbesondere Firebase Authentication, Cloud Firestore und Firebase Storage genutzt.
        </p>
        <p>
          Die Datenspeicherung erfolgt in der Region <strong>eur3</strong> innerhalb Europas.
          Es kann jedoch nicht ausgeschlossen werden, dass im Rahmen von Support-,
          Wartungs- oder konzerninternen Verarbeitungsprozessen Daten auch in Drittländer,
          insbesondere in die USA, übermittelt werden.
        </p>
       <p>
  Google LLC ist nach dem EU-U.S. Data Privacy Framework zertifiziert.
  Weitere Informationen finden Sie unter:
</p>

<p>
  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
    https://policies.google.com/privacy
  </a>
</p>

        <h2>5. Weitergabe von Daten</h2>
        <p>
          Eine Weitergabe personenbezogener Daten an Dritte erfolgt grundsätzlich nicht,
          es sei denn, dies ist gesetzlich vorgeschrieben oder für die technische Bereitstellung
          und den Betrieb der Plattform erforderlich.
        </p>

        <h2>6. Speicherdauer</h2>
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie dies für den Betrieb
          der Plattform, die Bereitstellung der jeweiligen Funktionen oder zur Erfüllung
          gesetzlicher Verpflichtungen erforderlich ist.
        </p>

        <h2>7. Ihre Rechte</h2>
        <p>
          Sie haben im Rahmen der gesetzlichen Vorschriften jederzeit das Recht auf:
        </p>
        <ul>
          <li>Auskunft über die zu Ihrer Person gespeicherten Daten</li>
          <li>Berichtigung unrichtiger Daten</li>
          <li>Löschung Ihrer Daten</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Widerspruch gegen die Verarbeitung, soweit gesetzlich vorgesehen</li>
          <li>Datenübertragbarkeit</li>
        </ul>

        <h2>8. Kontakt</h2>
        <p>
          Bei Fragen zum Datenschutz oder zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an:
        </p>
        <p>
          <strong>info@edens-ernte.app</strong>
        
        </p>
        <h2>9. Kontolöschung</h2>

<p>
Nutzer haben jederzeit die Möglichkeit, ihr Benutzerkonto und die damit verbundenen personenbezogenen Daten löschen zu lassen.
</p>

<p>
Informationen zur Kontolöschung finden Sie auf folgender Seite:
</p>

<p>
  In der App:
  <br />
  <Link to="/loeschen">Konto löschen (App-Seite)</Link>
</p>

<p>
  Oder direkt im Browser:
  <br />
  <a href="https://www.edens-ernte.app/loeschen" target="_blank" rel="noopener noreferrer">
    https://www.edens-ernte.app/loeschen
  </a>
</p>

<p>
Die Löschung des Kontos kann per E-Mail an <strong>info@edens-ernte.app</strong> angefordert werden.
</p>

      </div>
    </div>
  );
}

export default DatenschutzPage;